import angular from 'angular';
import activeAssessment from './activeAssessment';
import completedAssessment from './completedAssessment';
import maturityDomain from './maturityDomain';
import category from './category';
import directive from './assessments.directive';
import criFunciton from './criFunction';

export default angular.module('app.components.advisory.ecat.assessments', [
  activeAssessment,
  completedAssessment,
  category,
  maturityDomain,
  criFunciton
])
  .directive('ecatAssessments', directive)
  .controller('ECATAssessmentsController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.ecat.assessments created');
